module.exports = __webpack_public_path__ + "static/media/XMLID_3_.bfc3e97d.svg";